import SchemaBuilder from '@/components/schema/Builder'
import CyclicView from '@/components/cyclic/Cyclic'
import CyclicDefinition from '@/components/cyclic/CyclicDefinition'
import CyclicList from '@/components/cyclic/definition/List'
import EditCyclic from '@/components/cyclic/definition/Edit'
import CycleCreate from '@/components/cyclic/cycle/Create'
import CycleMainView from '@/components/cyclic/MainView'
import CycleForms from '@/components/form/Cycle'
import SchemaCycleList from '@/components/cyclic/cycle/SchemaList'
import SchemaList from '@/components/schema/List'
import SchemaTemplates from '@/components/schema/templates/List'
import SchemaTemplateUpload from '@/components/schema/templates/Upload'
import Login from '@/components/user/Login'
import TeamList from '@/components/team/List'
import UserList from '@/components/user/List'
import SingleFormView from '@/components/form/SingleView'
import FormFill from '@/components/form/Fill'
import FillGuest from '@/components/form/FillGuest'
import FormEdit from '@/components/form/Edit'
import NotFound from '@/components/NotFound'
import Dashboard from '@/components/Dashboard'
import UserView from '@/components/user/View'
import ArchiveList from '@/components/archive/List'
import Stats from '@/components/stats/List'
import RelatedList from '@/components/related/List'
import RelatedGroupType from '@/components/related/group/List'
import RelatedGroup from '@/components/related/group/Group'
import ValueList from '@/components/related/ValueList'
import DirList from '@/components/dirs/List'
import CreatePresentation from '@/components/form/presentation/Create'
import Translations from '@/components/schema/Translations'
import Rbac from '@/components/user/Rbac'
import WorkerPage from '@/components/document/worker/WorkerPage'
import NewDocument from '@/components/document/waiting/New'
import DocumentWaiting from '@/components/document/waiting/Waiting'
import DepartmentList from '@/components/department/List'
import OcrFieldMap from "@/components/schema/OcrFieldMap"
import EditDocument from "@/components/document/EditDocument"
import NewFormDocument from "@/components/document/NewFormDocument"
import Sections from "@/components/document/worker/Sections"
import ViewDocument from "@/components/document/View"
import OcrDocumentTemplate from "@/components/schema/DocumentTemplate"
import ArchiveDocumentList from '@/components/document/archive/ArchiveList'
import Settings from "@/plugins/Settings"
import TestList from "@/components/schema/TestList"
import AgencyList from '@/components/agency/List'
import CalendaryNew from '@/components/calendar/New'
import CalendarySchema from '@/components/calendar/Schema'
import Calendary from '@/components/calendar/Index'
import CalendarHistory from '@/components/calendar/HistoryAll'
import NewStorageItem from '@/components/storage/New'
import StorageProducts from '@/components/storage/Index'
import StorageHistory from '@/components/storage/History'
import StorageType from '@/components/storage/Type'
import MessageIndex from '@/components/message/Index'
import QrCode from '@/components/QrCode'
import MapToRelated from "../components/schema/MapToRelated.vue"
import RelatedMap from "../components/schema/RelatedMap.vue"
import SchemaAction from "../components/schema/actions/Actions.vue"
import Privilages from '../components/document/Privilages.vue'
import NewUserFile from '../components/shared/New.vue'
import ViewUserFile from '../components/shared/View.vue'
import KanbanView from '../components/schema/kanban/View.vue'
import KanbanCreate from '../components/schema/kanban/Create.vue'
import FieldRule from '../components/schema/FieldRule.vue'
import CopyData from "@/components/schema/CopyData.vue"

import {
  accessControl,
  hasRole,
  ifArchiveModuleAvalible,
  ifArchiveNavigationAvalible,
  ifAuthenticated,
  ifCalendarModuleAvalible,
  ifCyclicAvalible,
  ifCyclicNavigationAvalible,
  ifMessageModuleAvalible,
  ifNotAuthenticated,
  ifStatisticsNavigationAvalible,
  ifStorageModuleAvalible,
  ifUserFileModuleAvalible,
  isAllowed
} from './rules'

export default [
  {
    path: '/schema/:schemaId/copy-data',
    name: 'form-copy-data',
    component: CopyData,
    meta: {
      title: 'navigation.form-fill'
    }
  },
  {
    path: '/schema/:schemaId/field-rule',
    name: 'field-rule',
    component: FieldRule,
    meta: {
      title: 'navigation.form-fill'
    }
  },
  {
    path: '/form/:schemaId/kanban',
    name: 'kanban',
    component: KanbanView,
    meta: {
      title: 'navigation.form-fill'
    }
  },
  {
    path: '/schema/:schemaId/kanban',
    name: 'schema-kanban',
    component: KanbanCreate,
    meta: {
      title: 'Kanban'
    }
  },
  {
    path: '/f/:schemaName',
    name: 'form-fill-guest',
    component: FillGuest,
    meta: {
      title: 'navigation.form-fill'
    }
  },
  {
    path: '/',
    redirect: { name: Settings.getEntrypoint() }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    navigation: Settings.displayDashboard(),
    beforeEnter: ifAuthenticated,
    meta: {
      title: 'navigation.dashboard',
      icon: 'dashboard'
    }
  },
  {
    path: '/messages',
    name: 'messages',
    component: MessageIndex,
    navigation: ifMessageModuleAvalible() && accessControl.isAllowed('userList'),
    beforeEnter: ifAuthenticated,
    meta: {
      title: 'Wiadomości',
      icon: 'message'
    }
  },
  {
    path: '/user-files',
    name: 'user-files',
    component: ViewUserFile,
    navigation: ifUserFileModuleAvalible() && accessControl.hasRole('viewUserFile'),
    beforeEnter: isAllowed('viewUserFile'),
    meta: {
      title: Settings.moduleUserFileName(),
      icon: 'bookmark'
    }
  },
  {
    path: '/user-files/new',
    name: 'user-files-add',
    component: NewUserFile,
    navigation: false,
    beforeEnter: isAllowed('createUserFile'),
    meta: {
      title: Settings.moduleUserFileName() + " Dodawanie",
    }
  },
  {
    path: '/document/rules',
    name: 'document-rules',
    component: Privilages,
    navigation: false,
    beforeEnter: isAllowed('userEdit'),
    meta: {
      title: 'Uprawnienia dokumentów',
      icon: 'message'
    }
  },
  {
    path: '/schema/:schemaId/related-settings',
    name: 'map-schema-to-related',
    component: MapToRelated,
    beforeEnter: ifAuthenticated,
    meta: {
      title: 'Mapowanie do bazy relacyjnej',
    }
  },
  {
    path: '/schema/:schemaId/action',
    name: 'schema-action',
    component: SchemaAction,
    beforeEnter: ifAuthenticated,
    meta: {
      title: 'Akcje schematu',
    }
  },
  {
    path: '/schema/:schemaId/related-map',
    name: 'schema-related-map',
    component: RelatedMap,
    beforeEnter: ifAuthenticated,
    meta: {
      title: 'Mapowanie do bazy relacyjnej',
    }
  },
  {
    path: '/schema/:schemaId/calendar',
    name: 'calendar-schema',
    component: CalendarySchema,
    beforeEnter: ifAuthenticated,
    meta: {
      title: 'Szablon eventów kalendarza',
    }
  },
  {
    path: '/rbac',
    name: 'rbac',
    component: Rbac,
    beforeEnter: isAllowed('userEdit'),
    meta: {
      title: 'roles.permissions',
    }
  },
  {
    path: '/cycle/list',
    name: 'cycle-list',
    component: CycleMainView,
    navigation: ifCyclicNavigationAvalible(),
    sub_navigation: true,
    beforeEnter: ifCyclicAvalible,
    meta: {
      main_title: "Cykle",

      title: "Formularze cykliczne",
      icon: 'date_range'
    },
    children: [
      {
        path: '/cyclic/list',
        name: 'cyclic-list',
        component: CyclicList,
        navigation: true ,
        beforeEnter: isAllowed('viewSchema'),
        meta: {
          title: "Definicje cykli",
          icon: 'chrome_reader_mode'
        }
      }
    ]
  },
  {
    path: '/cyclic',
    name: 'cyclic-create',
    component: CyclicDefinition,
    navigation: false,
    beforeEnter: isAllowed('createSchema'),
    meta: {
      title: "Stowrz definicje cyklu"
    }

  },
  {
    path: '/cyclic/edit/:cyclicId',
    name: 'cyclic-edit',
    component: EditCyclic,
    navigation: false,
    beforeEnter: isAllowed('createSchema'),
    meta: {
      title: "Edytuj definicje",
    }
  },
  {
    path: '/cyclic/view/:cyclicId',
    name: 'cyclic-view',
    component: CyclicView,
    navigation: false,
    beforeEnter: isAllowed('viewSchema'),
    meta: {
      title: "Cykl"
    }
  },
  {
    path: '/cycle/create',
    name: 'cycle-create',
    component: CycleCreate,
    beforeEnter: isAllowed('createSchema'),
    meta: {
      title: "Stwórz cykl"
    }
  },
  {
    path: '/cycle/:cycleId/schemas',
    name: 'cycle-schemas',
    component: SchemaCycleList,
    beforeEnter: isAllowed('viewSchema'),
    meta: {
      title: "Schematy cyklu "
    }
  },
  {
    path: '/cycle/:cycleId/forms/:schemaId',
    name: 'cycle-forms',
    component: CycleForms,
    beforeEnter: ifAuthenticated,
    meta: {
      title: "Formularze"
    }
  },
  {
    path: '/schemas',
    name: 'schema-list',
    component: SchemaList,
    navigation: !(Settings.hiddenSchemaForWorker() && accessControl.isWorker()),
    permission : "viewSchema",
    beforeEnter: accessControl.routeGuardBuilder().can('viewForm').or('viewSchema').build(),
    meta: {
      title: 'navigation.schema-list',
      icon: 'library_books'
    }
  },
  {
    path: '/tests',
    name: 'test-list',
    component: TestList,
    navigation: Settings.displayTest(),
    meta: {
      title: 'Testy',
      icon: 'library_books'
    }
  },
  {
    path: '/document/workers',
    name: 'document-workers',
    component: WorkerPage,
    navigation: Settings.documentAvallible(),
    permission : "viewSchema",
    beforeEnter: accessControl.routeGuardBuilder()
      .can('viewForm').or('viewSchema').build(),
    meta: {
      title: Settings.moduleWorkerDocumentName(),
      icon: 'table'
    }
  },
  {
    path: '/document/map/schema/:schemaId',
    name: 'document-map',
    component: OcrFieldMap,
    beforeEnter:  isAllowed('createSchema'),
    meta: {
      title: 'navigation.schema-edit'
    }
  },
  {
    path: '/document/template/schema/:schemaId',
    name: 'document-template',
    component: OcrDocumentTemplate,
    beforeEnter:  isAllowed('createSchema'),
    meta: {
      title: 'navigation.schema-edit'
    }
  },
  {
    path: '/document/schema/:schemaId/briefcase/:briefcaseGuid',
    name: 'document-form-view-by-worker',
    component: ViewDocument,
    beforeEnter:  isAllowed('viewSchema'),
    meta: {
      title: 'Dokumenty'
    }
  },
  {
    path: '/document/schema/:schemaId/form/:formId/edit',
    name: 'document-form-edit',
    component: EditDocument,
    beforeEnter:  isAllowed('editDocumentType'),
    meta: {
      title: 'Edycja dokumentu'
    }
  },
  {
    path: '/document/:documentId/create-form',
    name: 'document-create-form',
    component: NewFormDocument,
    beforeEnter:  isAllowed('editDocumentType'),
    meta: {
      title: 'Przypisywanie dokumentu'
    }
  },
  {
    path: '/document/briefcase/:briefcaseGuid/all',
    name: 'documents-briefcase',
    component: Sections,
    navigation: false,
    permission : "viewSchema",
    beforeEnter: accessControl.routeGuardBuilder()
      .can('viewForm').or('viewSchema').build(),
    meta: {
      title: 'Dokumenty pracownika',
    }
  },
  {
    path: '/document/new',
    name: 'new-document',
    component: NewDocument,
    navigation: false,
    permission : "viewSchema",
    beforeEnter: accessControl.routeGuardBuilder()
      .can('viewForm').or('viewSchema').build(),
    meta: {
      title: 'Nowy Dokument',
    }
  },
  {
    path: '/document/waiting',
    name: 'document-waiting',
    component: DocumentWaiting,
    navigation: Settings.documentAvallible(),
    permission : "viewSchema",
    beforeEnter: accessControl.routeGuardBuilder()
      .can('viewForm').or('viewSchema').build(),
    meta: {
      title: 'Poczekalnia',
      icon: "call_merge"
    }
  },
  {
    path: '/document/archive',
    name: 'document-archive',
    component: ArchiveDocumentList,
    navigation: Settings.documentAvallible(),
    permission : "viewSchema",
    beforeEnter: accessControl.routeGuardBuilder()
      .can('viewForm').or('viewSchema').build(),
    meta: {
      title: 'Archiwum',
      icon: "storage"
    }
  },
  {
    path: '/form/:schemaId/id/:formId',
    name: 'single-form-view',
    component: SingleFormView,
    beforeEnter: isAllowed('viewSchema'),
    meta: {
      title: 'navigation.form-view'
    }
  },
  {
    path: '/schema/builder',
    name: 'schema-builder',
    component: SchemaBuilder,
    navigation: true,
    permission : "createSchema",
    beforeEnter: isAllowed('createSchema'),
    meta: {
      title: 'navigation.schema-builder',
      icon: 'library_add'
    }
  },
  {
    path: '/schema/:schemaId/update',
    name: 'schema-update',
    component: SchemaBuilder,
    beforeEnter:  isAllowed('createSchema'),
    meta: {
      title: 'navigation.schema-edit'
    }
  },
  {
    path: '/schema/:schemaId/presentation',
    name: 'schema-presentation',
    component: CreatePresentation,
    beforeEnter:  isAllowed('createSchema'),
    meta: {
      title: 'navigation.schema-edit'
    }
  },
  {
    path: '/schema/:schemaId/translations',
    name: 'schema-translation',
    component: Translations,
    beforeEnter:  isAllowed('createSchema'),
    meta: {
      title: 'navigation.schema-edit'
    }
  },
  {
    path: '/storage/new',
    name: 'storage-new',
    beforeEnter: isAllowed('createStorage'),
    component: NewStorageItem,
  },
  {
    path: '/storage/history',
    name: 'storage-history',
    beforeEnter: isAllowed('viewStorageHistory'),
    component: StorageHistory,
    meta: {
      title: 'Historia magazynu'
    }
  },
  {
    path: '/storage/type',
    name: 'storage-type',
    beforeEnter: isAllowed('viewStorage'),
    component: StorageType,
    meta: {
      title: 'Typy magazynów'
    }
  },
  {
    path: '/storage',
    name: 'storage-products',
    beforeEnter: isAllowed('viewStorage'),
    navigation: ifStorageModuleAvalible() && accessControl.isAllowed('viewStorage'),
    meta: {
      title: 'Magazyn',
      icon:'storage'
    },
    component: StorageProducts,
  },
  {
    path: '/calendar/new',
    name: 'celendar-new',
    component: CalendaryNew,
    beforeEnter: ifAuthenticated,
    meta: {
      title: 'Events',
    }
  },
  {
    path: '/calendar/:id/update',
    name: 'celndar-update',
    component: CalendaryNew,
    beforeEnter: ifAuthenticated,
    meta: {
      title: 'Events',
    }
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: Calendary,
    navigation: ifCalendarModuleAvalible() && accessControl.isAllowed('viewCalendarEvent'),
    beforeEnter: isAllowed('viewCalendarEvent'),
    meta: {
      title: 'Kalendarz',
      icon:'calendar_month'
    }
  },
  {
    path: '/calendar/history',
    name: 'calendar-history',
    component: CalendarHistory,
    beforeEnter: isAllowed('historyCalendarEvent'),
    meta: {
      title: 'Kalendarz - Historia',
      icon:'calendar_month'
    }
  },
  {
    path: '/teams',
    name: 'team-list',
    component: TeamList,
    navigation: true,
    permission : "teamEdit",
    beforeEnter: isAllowed('teamEdit'),
    meta: {
      title: 'navigation.team-list',
      icon: 'group'
    }
  },
  {
    path: '/departments',
    name: 'departments',
    component: DepartmentList,
    navigation: false,
    permission : "department",
    beforeEnter: isAllowed('teamEdit'),
    meta: {
      title: 'department.departments',
    }
  },
  {
    path: '/agencies',
    name: 'agencies',
    component: AgencyList,
    navigation: false,
    permission : "agency",
    beforeEnter: isAllowed('teamEdit'),
    meta: {
      title: 'agency.agencies',
    }
  },
  {
    path: '/users',
    name: 'user-list',
    component: UserList,
    navigation: true,
    permission : "userEdit",
    beforeEnter: isAllowed('userEdit'),
    meta: {
      title: 'navigation.user-list',
      icon: 'person'
    }
  },
  {
    path: '/archive',
    name: 'archive-list',
    component: ArchiveList,
    navigation: ifArchiveNavigationAvalible(),
    permission : "createSchema",
    beforeEnter: ifArchiveModuleAvalible,
    meta: {
      title: 'navigation.archive',
      icon: 'markunread_mailbox'
    }
  },
  {
    path: '/dirs',
    name: 'dir-list',
    component: DirList,
    navigation: true,
    permission: "viewSchema",
    beforeEnter: isAllowed('viewSchema'),
    meta: {
      title: 'dir.folders',
      icon: 'folder'
    }
  },
  {
    path: '/stats',
    name: 'stats',
    component: Stats,
    navigation: ifStatisticsNavigationAvalible(),
    beforeEnter: isAllowed('createSchema'),
    permission : "createSchema",
    meta: {
      title: "stats.stats",
      icon: 'trending_up'
    }
  },
  {
    path: '/user/:idUser',
    name: 'user-view',
    component: UserView,
    beforeEnter: isAllowed('userEdit'),
    meta: {
      title: 'navigation.user-view'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    navigation: true,
    beforeEnter: ifNotAuthenticated,
    meta: {
      title: 'navigation.login',
      icon: 'lock_open'
    }
  },
  {
    path: '/form/:schemaId',
    name: 'form-view',
    component: Settings.getFormView(),
    beforeEnter: isAllowed('viewForm'),
    meta: {
      title: 'navigation.form-view'
    }
  },
  {
    path: '/related-fields',
    name: 'related-list',
    navigation: true,
    permission : "createSchema",
    component: RelatedList,
    beforeEnter: isAllowed('createSchema'),
    meta: {
      title: "related.related_schema",// 'navigation.form-view',
      icon: 'device_hub'
    }
  },
  {
    path: '/mobile-settings',
    name: 'Konfiguracja mobilna',
    component: QrCode,
    navigation: accessControl.isAdmin(),
    beforeEnter: hasRole('admin'),
    meta: {
      title: 'Ustawienia aplikacji',
      icon: 'phone_android'
    }
  },
  {
    path: '/related/groups',
    name: 'related-group',
    navigation: false,
    component: RelatedGroup,
    beforeEnter: isAllowed('createSchema'),
    meta: {
      title: "Grupy relacyjne",// 'navigation.form-view',
      icon: 'device_hub'
    }
  },
  {
    path: '/related/groups/type',
    name: 'related-group-type',
    navigation: false,
    component: RelatedGroupType,
    beforeEnter: isAllowed('createSchema'),
    meta: {
      title: "Typy grup",// 'navigation.form-view',
      icon: 'device_hub'
    }
  },
  {
    path: '/related-fields/:schemaId',
    name: 'related-values',
    navigation: false,
    component: ValueList,
    beforeEnter: isAllowed('createSchema'),
    meta: {
      title: "Pola powiazane",// 'navigation.form-view',
      icon: 'lock_open'
    }
  },
  {
    path: '/form/:schemaId/fill',
    name: 'form-fill',
    component: FormFill,
    beforeEnter: isAllowed('fillForm'),
    meta: {
      title: 'navigation.form-fill'
    }
  },
  {
    path: '/form/:schemaId/edit/:formId',
    name: 'form-edit',
    component: FormEdit,
    beforeEnter: isAllowed('fillForm'),
    meta: {
      title: 'navigation.form-fill'
    }
  },
  {
    path: '/schema/:schemaId/templates',
    name: 'schema-templates',
    component: SchemaTemplates,
    beforeEnter: isAllowed('uploadTemplate'),
    meta: {
      title: 'navigation.templates'
    }
  },
  {
    path: '/schema/:schemaId/template/upload',
    name: 'schema-template-upload',
    component: SchemaTemplateUpload,
    beforeEnter: isAllowed('uploadTemplate'),
    meta: {
      title: 'navigation.template-upload'
    }
  },
  {
    path: '*',
    name: 'not-found',
    component: NotFound,
    beforeEnter: ifAuthenticated,
    meta: {
      title: 'navigation.not-found',
      icon: 'error_outline'
    }
  }
]
